import { Stack, useToast } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormFooter } from "components/ui";
import {
  GetRegistryByIdToEditQuery,
  RegistryInput,
  useUpdateRegistryMutation,
} from "graphql/queries/generated/queries";
import { ValidationProvider } from "components/form/ValidationContext";
import { RegistryInputSchema } from "graphql/queries/generated/validation-schema";
import { useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { handleMutation } from "middleware/Toaster";
import RegistryFields from "../shared/RegistryFields";

interface PageProps {
  data: GetRegistryByIdToEditQuery;
}

const Page = ({ data }: PageProps) => {
  const {
    registry: { __typename, id, ...registry },
  } = data;

  const toast = useToast();

  const [updateRegistry, { data: updateRegistryData, error, loading }] = useUpdateRegistryMutation({
    ...handleMutation("Registry updated!"),
  });

  let categoriesCompany: string[] = null;
  let categoriesPerson: string[] = null;

  if (registry.isCompany) {
    categoriesCompany = registry.categories;
    categoriesPerson = [];
  } else {
    categoriesCompany = [];
    categoriesPerson = registry.categories;
  }

  const methods = useForm<RegistryInput>({
    defaultValues: {
      categoriesCompany,
      categoriesPerson,
      ...registry,
    },
    resolver: yupResolver(RegistryInputSchema()),
  });

  const {
    formState: { errors },
    setFocus,
  } = methods;

  useEffect(() => {
    console.log(errors);

    const firstError = Object.keys(errors).reduce(
      (field, a) => ((errors as unknown as never)[field] ? field : a),
      null
    );

    try {
      if (firstError) {
        setFocus(firstError as keyof RegistryInput);
      }
    } catch (e) {
      console.log(e);
    }
  }, [errors, setFocus]);

  const onSubmit: SubmitHandler<RegistryInput> = async (formData, e) => {
    console.log(formData);

    await updateRegistry({
      variables: {
        input: {
          id,
          registryData: {
            ...formData,
          },
        },
      },
    });

    return null;
  };

  return (
    <Stack spacing="4">
      <ValidationProvider schema={RegistryInputSchema()}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <RegistryFields watch={methods.watch} setValue={methods.setValue} registryId={id} />
            <FormFooter
              data={updateRegistryData}
              loading={loading}
              errors={[error]}
              title="Registry entry"
            />
          </form>
        </FormProvider>
      </ValidationProvider>
    </Stack>
  );
};

export default Page;
